import React from "react";
import { siteConfig, siteTheme } from "../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../Configurer";
import ProfileImage from "../partials/ProfileImage";
import TableViewer from "../TableViewer";
import { v4 as uuidv4 } from 'uuid';
import ItemModal from "../../modals/ItemModal";
import HttpServices from "../../utils/Http.services";
import RemoveModal from "../../modals/RemoveModal";
import { checkTextTranslation, checkTranslation, pathMaker, translate } from "../../utils/useful";
import AddUserModal from "../../modals/AddUserModal";


class FormView extends React.Component {


    openEditModal = (prop, index) => {
        // console.log('qwdwfasdvsvsdvsvsdvasv', prop, index);

        console.log(this.props.page?.addNew)
        if (this.props.page?.addNew) {

            if (this.props.page?.addNew?.function) {
                if (this[this.props.page?.addNew?.function]) {
                    this[this.props.page?.addNew?.function](this.props.page?.addNew?.functionInput)
                }

            } else if (this.props.page?.addNew?.page) {
                let newPage = this.props.route + this.props.page?.addNew.page
                this.props.history.push(pathMaker(newPage + '?id=' + prop._id + '&ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
            }
            else {
                let newPage = this.props.page?.addNew
                if (this.props.page?.addNew.includes('../')) {
                    newPage = this.props.route + this.props.page?.addNew.replace('..', '')
                }
                this.props.history.push(pathMaker(newPage + '?id=' + prop._id + '&ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
            }
        } else {
            // this.itemModal?.modal?.showModal()
            
            this.setState({ currentItem: prop, currentIndex: index },() => {
                this.itemModal?.modal?.open()

            } )
        }
    }


    // changeStage=(stage)=>{
    //     // console.log(stage)
    //     this.props.changeStage(stage)
    // }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    state = {
        data: [],
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: this.openEditModal },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal }
        },
    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {

        if (this.props.page && this.props.page !== prevProps.page && this.props.pageType == prevProps.pageType) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
    }


    init() {

        if (this.props.page) {
            this.setState({ data: [] }, () => {
                this.fetchData()
            })
        }
    }

    fetchData = () => {

        this.setState({ isLoadingData: true })
        let body = this.props.page.filter ?? {}
        let page = this.props.page
        body.page = page.key

        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }
        console.log('fetchData01',this.props.page)
        console.log(page.fetchUrl)
        console.log(body)

        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })

            if (fetchError) {
                // console.log("DKLADKA")
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            // console.log(fetchResult)
            this.setState({ data: fetchResult.info })
        })
    }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })


        })

    }

    itemAdded = (newItem) => {
        let data = this.state.data
        data.splice(0, 0, newItem)
        // console.log(newItem)
        // console.log(data)
        this.setState(data)
    }

    itemEdited = (editedItem) => {
        // console.log(editedItem)
        let data = this.state.data
        this.state.data.forEach((element, index) => {
            let id = element.id ?? element._id
            let currentId = this.state.currentItem.id ?? this.state.currentItem._id
            if (id === currentId) {
                // console.log(id)
                data[index] = Object.assign({}, editedItem)
            }
        });
        this.setState({ data }, () => {
            // console.log(editedItem)
            // console.log(data)
            // this.TableViewer.forceUpdateData()
        })
    }

    updateData = (data) => {
        this.setState(data)
    }


    openAddNew = () => {
        // console.log(this.props.page)
        if (this.props.page?.addNew) {

            if (this.props.page?.addNew?.function) {
                if (this[this.props.page?.addNew?.function]) {
                    this[this.props.page?.addNew?.function](this.props.page?.addNew?.functionInput)
                }

            }
            // else if (this.props.page?.addNew?.page) {
            //     let newPage = this.props.route + this.props.page?.addNew.page
            //     this.props.history.push(pathMaker(newPage + '?ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
            // }
            else {
                this.props.changePage(this.props.page?.addNew)
                // console.log(this.props.page?.addNew)
                // let newPage = this.props.page?.addNew
                // if (this.props.page?.addNew.includes('../')) {
                //     newPage = this.props.route + this.props.page?.addNew.replace('..', '')
                // }
                // this.props.history.push(pathMaker(newPage + '?ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
            }
        } else {
            this.openEditModal()
        }
    }

    openInviteUser() {
        this.addUserModal.showModal()
    }

    openEditUser(prop, index) {
        this.setState({ currentItem: prop, currentIndex: index }, () => {
            this.addUserModal.showModal(true)
        })
    }

    functionsHandler = (prop, index, reference) => {
        if (this[reference.function]) {
            this[reference.function](prop, index, reference)
        }
    }

    render() {
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTextTranslation(this.props.page?.title), button: { goBack: true } }}
                title={checkTextTranslation(this.props.page?.title)}
                description={checkTextTranslation(this.props.page?.description)}
                className=""
            >


                <div className="" style={{ background: 'rgb(248, 248, 249)', minHeight: this.props.height }}>
                    <div className=" m-0">
                        <div className=" p-0" >
                            <div className="p-0" style={{ borderRadius: 0 }}>

                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>

                                    <div className="flexc mt-2">
                
                                        <ProfileImage width={20} borderRadius={50} notif={0} border={'2px solid #eee'} className={'mrd-3'} data={{ image: this.props.page?.image ?? this.props.page?.icon }} />

                                        <div>
                                            <p className="font-size-12 m-0 " style={{ color: '#222' }}>{checkTranslation(this.props.page?.title)}</p>
                                            <p className="text-small m-0" style={{ color: '#89a',whiteSpace:'pre-wrap' }} >{this.props.page?.description}</p>
                                        </div>
                                    </div>


                                    <div className="flexcc mt-2" style={{ alignItems: 'flex-end' }}>
                                        {this.props.page?.addNew != -1 && (
                                            <button onClick={() => this.openAddNew()} className="flexcc" style={{ boxShadow: '0px 0px 15px #00000005', backgroundImage: 'linear-gradient(#000,#102030)', border: '0px solid #e9eaf0', color: '#789', borderRadius: 30, padding: '7px 15px' }}>
                                                <img className="mrd-2 invert" src="/images/add.svg" alt="" width="12px" />
                                                <span className="text-smaller m-0 white text-bold" >{this.props.page?.addNew?.title ? checkTranslation(this.props.page?.addNew?.title) : translate('useful.addNew')}</span>
                                            </button>
                                        )}
                                    </div>

                                </div>
                            </div>

                        </div>



                        <div className=" mb-5 mt-2 w-100 p-0">
                            <TableViewer
                                isLoading={this.state.isLoadingData}
                                headers={this.props.page?.headers}
                                pages={this.props.page?.pages}
                                data={this.state.data}
                                actions={this.props.page?.actions ?? this.state.actions}
                                settings={{ isSortable: false }}
                                openEditModal={this.openEditModal}
                                openRemoveModal={this.openRemoveModal}
                                updateData={this.updateData}
                                functionsHandler={this.functionsHandler}

                                ref={el => this.TableViewer = el}
                            />
                        </div>


                    </div>


                    <ItemModal
                        ref={el => this.itemModal = el}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        pages={this.props.page?.pages}
                        initData={this.state.currentItem}
                        variables={this.props.variables}
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                        width={this.props.width}
                        showDates={true}
                    />

                    {this.state.extraItems && this.state.extraItems.map((prop, index) => {
                        return (

                            <ItemModal
                                ref={el => this["itemModal" + index] = el}
                                page={prop.page}
                                headers={prop.page?.headers}
                                pages={prop.page?.pages}

                                initData={prop.data}
                                variables={this.props.variables}
                                itemAdded={this.itemAdded}
                                itemEdited={this.itemEdited}
                                openRefModal={this.openRefModal}
                                functionsHandler={this.functionsHandler}
                                showDates={true}
                                modalIndex={index}
                            />
                        )

                    })}


                    <RemoveModal
                        isLoading={this.state.isLoadingRemove}
                        removeFunction={this.fetchRemove}
                        ref={el => this.removeModal = el}
                    />

                    <AddUserModal
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                        ref={el => this.addUserModal = el}
                        variables={this.props.variables}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        initData={this.state.currentItem}
                    />

                </div>
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormView);
